import { COUNTRY_CODES } from "@salon-pos/shared";

const INTL_LOCALE: Record<string, string> = { en: "en", zh: "zh-Hans", ms: "ms" };

/** Country display name in the UI language (Intl.DisplayNames), falling back to the code. */
export function countryName(code: string, uiLocale: string): string {
  try { return new Intl.DisplayNames([INTL_LOCALE[uiLocale] ?? uiLocale, "en"], { type: "region" }).of(code) ?? code; } catch { return code; }
}

export function currencyName(code: string, uiLocale: string): string {
  try { return new Intl.DisplayNames([INTL_LOCALE[uiLocale] ?? uiLocale, "en"], { type: "currency" }).of(code) ?? code; } catch { return code; }
}

/** Every country, sorted by its localized name. */
export function countryOptions(uiLocale: string): Array<{ code: string; name: string }> {
  const collator = new Intl.Collator(INTL_LOCALE[uiLocale] ?? "en");
  return COUNTRY_CODES.map((code) => ({ code, name: countryName(code, uiLocale) })).sort((a, b) => collator.compare(a.name, b.name));
}

/** Guess the visitor's country from the browser language (e.g. en-MY -> MY). */
export function guessCountry(): string {
  const langs = typeof navigator !== "undefined" ? [...(navigator.languages ?? []), navigator.language] : [];
  for (const l of langs) {
    const m = /-([A-Z]{2})$/i.exec(l ?? "");
    if (m && COUNTRY_CODES.includes(m[1]!.toUpperCase())) return m[1]!.toUpperCase();
  }
  return "MY";
}

/** All IANA time zones supported by the browser. */
export function timeZones(): string[] {
  try { return (Intl as unknown as { supportedValuesOf(k: string): string[] }).supportedValuesOf("timeZone"); } catch { return ["UTC"]; }
}

export function currencies(): string[] {
  try { return (Intl as unknown as { supportedValuesOf(k: string): string[] }).supportedValuesOf("currency"); } catch { return ["USD"]; }
}

export const FORMAT_LOCALES = ["en-MY", "ms-MY", "zh-MY", "en-SG", "zh-SG", "en-US", "en-GB", "en-AU", "en-NZ", "en-CA", "fr-CA", "en-IN", "en-PH", "en-HK", "zh-HK", "zh-TW", "zh-CN", "ja-JP", "ko-KR", "th-TH", "id-ID", "vi-VN", "de-DE", "de-AT", "de-CH", "fr-FR", "fr-BE", "nl-NL", "nl-BE", "es-ES", "es-MX", "pt-PT", "pt-BR", "it-IT", "sv-SE", "nb-NO", "da-DK", "fi-FI", "pl-PL", "cs-CZ", "hu-HU", "ro-RO", "el-GR", "tr-TR", "ar-AE", "ar-SA", "he-IL", "en-ZA", "en-IE", "en-AE"];
